<template>
  <div class="CarouselPagination">
    <span class="CarouselPagination-active" ref="active">{{
      activeIndex
    }}</span>
    <span class="CarouselPagination-len"> / {{ len }}</span>
  </div>
</template>

<script>
import gsap from "gsap";

export default {
  props: {
    active: {
      type: Number,
      required: true,
    },
    len: {
      type: Number,
      required: true,
    },
  },
  data: vm => {
    return {
      activeIndex: vm.active,
    };
  },
  watch: {
    active(value) {
      const { $refs } = this;
      gsap.to($refs.active, 0.3, {
        alpha: 0,
        y: "-40%",
        ease: "power2.in",
        onComplete: () => {
          this.activeIndex = value;
        },
      });
      gsap.delayedCall(0.3, () => {
        gsap.fromTo(
          $refs.active,
          0.7,
          { alpha: 0, y: "40%" },
          { alpha: 1, y: "0%", ease: "power2.out" },
        );
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './CarouselPagination.styl';
</style>
